const state = () => ({
  quotes: [],
  latestQuotes: {},
  healthPurchaseHistory: {}
})

export default state
